import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {Article} from '../models/article.models';

@Component({
    selector: 'article-warning',
    templateUrl: './article-warning.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ArticleWarningComponent {
  @Input() article?: Article;
}
